import { type AvatarViewingContext } from '@procurify/ui'
import { useSelector } from 'react-redux'

import { makeSelectUser } from '@webapp/core/stores/global'

export const useUserAvatarViewingContext = (
  userId?: number,
  viewingContextOverride?: AvatarViewingContext
): AvatarViewingContext => {
  const loggedInUser = useSelector(makeSelectUser())

  return (
    viewingContextOverride ??
    (userId != null && loggedInUser?.id === userId ? 'self' : 'others')
  )
}
